import React from 'react';
import { Quote, MapPin, TrendingUp } from 'lucide-react';
import { mockData } from './mockData';

const Testimonials = () => {
  const { testimonials } = mockData;

  return (
    <section id="testimonials" className="section section-bg">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">What Our Clients Say</h2>
          <p className="body-large max-w-2xl mx-auto">
            Real results from real businesses. See how AI automation has transformed 
            operations for local service providers across different industries.
          </p>
        </div>

        <div className="voice-grid max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id} 
              className={`voice-card ${index % 2 === 0 ? 'accent-blue' : 'accent-orange'} hover-lift`}
            >
              {/* Quote Icon */}
              <div className="mb-4">
                <Quote size={24} className="text-gray-400" />
              </div>

              {/* Quote Text */}
              <blockquote className="voice-card-description mb-6 italic">
                "{testimonial.quote}"
              </blockquote>

              {/* Savings/Results Badge */}
              <div className="mb-4">
                <div className="inline-flex items-center gap-2 bg-green-50 text-green-800 px-3 py-1 rounded-full text-sm">
                  <TrendingUp size={14} />
                  {testimonial.savings}
                </div>
              </div>

              {/* Author Info */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
                  <span className="text-sm font-medium text-gray-600">
                    {testimonial.name.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <div>
                  <div className="font-medium text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.business}</div>
                  <div className="flex items-center gap-1 text-xs text-gray-500">
                    <MapPin size={12} />
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Industries Section */}
        <div className="mt-16">
          <h3 className="heading-2 text-center mb-8">Industries We Serve</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {mockData.industries.map((industry, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 bg-white rounded-lg shadow-sm flex items-center justify-center mx-auto mb-3">
                  {/* Using text instead of dynamic icons for simplicity */}
                  <span className="text-2xl">
                    {industry.name === 'Healthcare' ? '🏥' : 
                     industry.name === 'Legal Services' ? '⚖️' : 
                     industry.name === 'Home Services' ? '🔧' : 
                     industry.name === 'Beauty & Wellness' ? '✨' : 
                     industry.name === 'Professional Services' ? '🏢' : '🚗'}
                  </span>
                </div>
                <h4 className="font-medium text-sm mb-1">{industry.name}</h4>
                <p className="text-xs text-gray-600">{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;